import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CityworksAuthResponse } from './cityworks-auth-response';
import { CityworksSrResponse } from './cityworks-sr-response';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CityworksService {

  private cwAuthUrl = 'https://cityworks.raleighnc.gov/admin/services/General/Authentication/Authenticate';
  private cityworksSRUrl = 'https://cityworks.raleighnc.gov/admin/Services/AMS/ServiceRequest/';

  constructor(private http: HttpClient) {}

  getToken(): Observable<CityworksAuthResponse> {
    const login = { LoginName: environment.user, Password: environment.password };
    const params = new HttpParams().append('data', JSON.stringify(login));
    return this.http.post<CityworksAuthResponse>(this.cwAuthUrl, null, { params })
      .pipe(catchError(this.handleError));
  }

  createServiceRequest(request: any, token: string): Observable<CityworksSrResponse> {
    const body = new HttpParams()
      .append('token', token)
      .append('data', JSON.stringify(request));
    return this.http.post<CityworksSrResponse>(`${this.cityworksSRUrl}Create`, body)
      .pipe(catchError(this.handleError));
  }

  getServiceRequest(requestId: any, token: string): Observable<CityworksSrResponse> {
    const body = new HttpParams()
      .append('token', token)
      .append('data', JSON.stringify(requestId));
    return this.http.post<CityworksSrResponse>(`${this.cityworksSRUrl}ById`, body)
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    return throwError(() => new Error('Something went wrong; please try again later.'));
  }
}
